import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';
import SectionTitle from './SectionTitle';

const { FiArrowUpRight, FiSearch, FiClock } = FiIcons;
const AUDIT_URL = 'https://audit.jam.jellylocal.com/light-audit/search';

export default function AuditTool() {
  return (
    <section>
      <SectionTitle eyebrow="Partner prospecting tool" title="Start the conversation with an audit.">
        Use the audit tool to find opportunities for prospective customers and give them a clear reason to talk about their local visibility.
      </SectionTitle>

      <div className="mt-8 flex flex-col gap-5 rounded-3xl bg-[#0b1423] p-6 text-white sm:flex-row sm:items-center sm:justify-between sm:p-8">
        <div className="flex items-start gap-4">
          <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-[#3fc0fa] text-[#0b1423]">
            <SafeIcon icon={FiSearch} className="h-6 w-6" />
          </span>
          <div>
            <h3 className="text-xl font-black">Find your next customer</h3>
            <p className="mt-2 max-w-xl text-sm leading-relaxed text-slate-300">
              Run a light audit, spot local marketing opportunities, and use the findings to guide your outreach.
            </p>
          </div>
        </div>
        <a
          href={AUDIT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="site-button inline-flex w-full shrink-0 items-center justify-center gap-2 rounded-full px-7 py-4 font-bold sm:w-auto"
        >
          Open audit tool <SafeIcon icon={FiArrowUpRight} />
        </a>
      </div>

      <aside className="mt-5 flex items-start gap-4 rounded-2xl border border-[#3fc0fa]/40 bg-[#eaf8ff] p-5 text-[#0b1423] sm:p-6">
        <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#3fc0fa]">
          <SafeIcon icon={FiClock} className="h-5 w-5" />
        </span>
        <div>
          <h3 className="text-lg font-black">Looking for an old report?</h3>
          <p className="mt-2 leading-relaxed text-slate-700">
            You don’t need to save a list of report links. In the audit tool, search for the business name and its city and state—just like a Google Business search—to find its report again.
          </p>
        </div>
      </aside>

      <div className="mt-6 overflow-hidden rounded-3xl border border-slate-200 bg-slate-50">
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-slate-200 px-5 py-4">
          <p className="font-semibold text-[#0b1423]">Light audit</p>
          <a href={AUDIT_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-bold text-blue-700 hover:underline">
            Open full screen <SafeIcon icon={FiArrowUpRight} />
          </a>
        </div>
        <iframe src={AUDIT_URL} title="Jelly Local light audit tool" loading="lazy" className="h-[70vh] min-h-[520px] w-full" />
      </div>
      <p className="mt-3 text-sm text-slate-500">
        If the tool does not appear above, use “Open audit tool” to launch it in a new tab.
      </p>
    </section>
  );
}